import styled from '@emotion/styled';

export const StyleRegisterLicenseWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
  width: 100vw;
  height: calc(100vh - 80px);
  @media (max-width: 888px) {
    height: 100%;
  }
`;
export const StyleRegisterLicenseForm = styled.div`
  position: relative;
  width: 800px;
  min-width: 600px;
  min-height: 509px;
  margin: 0 auto;
  padding: 40px 0 40px 0;
  border-top: 5px solid #7fe200;
  background: #ffffff;
`;

export const StyleRegisterLicenseField = styled.div`
  position: relative;
  padding: 0 98px;
  border: none;

  & .go_back {
    display: inline-block;
    width: 124px;
    line-height: 48px;
    text-align: center;
    border-radius: 50px;
    text-decoration: none;
    background-color: #555;
    color: #fff;
  }
  & section {
    position: absolute;
    right: 98px;
    bottom: 0;
  }
`;

export const StyleRegisterLicenseTitle = styled.h1`
  height: 40px;
  margin-bottom: 25px;
  line-height: 40px;
  text-align: center;
  font-weight: bold;
  font-size: 32px;
  color: #00bf00;
`;

export const StyleLicenseCode = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 15px auto 30px;
  & div {
    & + div {
      width: calc(100% - 147px);
    }

    & input {
      width: 100%;
      min-width: 200px;
      padding-right: 140px;
      border-radius: 5px;
      border-right-width: 1px;
      &:focus-visible {
        border-right-width: 1px;
      }
      &:focus,
      &:active {
        & + div {
          & + label {
            border-color: #7fe200;
          }
        }
      }
    }
    & input[data-invalid] {
      &:not([data-invalid='']) {
        & + div {
          & + label {
            border-color: #ff4c4c;
          }
        }
      }
    }

    & input[data-invalid] {
      &:is([data-invalid='']) {
        & + div {
          & + label {
            border-color: #7fe200;
          }
        }
      }
    }

    & label[for='txt-upload-input'] {
      position: absolute;
      top: 1px;
      right: 1px;
      height: 38px;
      min-width: 100px;
      max-width: 124px;
      border: none;
      border-left: 1px solid #e0e0e0;
    }
  }

  & button {
    width: 127px;
    height: 36px;
    margin-left: auto;
    font-size: 14px;
  }
`;

export const StyleCompanyInfo = styled.div`
  margin: 15px auto 30px;
`;

export const StyleCreateAccount = styled.div`
  margin: 15px auto 30px;
  & div {
    width: 100%;
  }
  & > div {
    margin-top: 30px;
  }

  & .pwd {
    & .validate-txt {
      &::after {
        position: absolute;
        left: 0;
        top: 100%;
        width: 100%;
        font-size: 13px;
        text-align: left;
        content: "Use at least 10 characters. (letters, numbers and symbols other than \<\>\\'\&\\"\(\)\#)";
      }
    }
    &.confirmPwd {
      & .validate-txt {
        &::after {
          content: "Enter the same password.";
        }
      }
    }
  }
 
  

  input[data-invalid$='validate-mix' i] {
    & ~ div[data-type='validate'] {
      &::after {
        content: 'Please enter a valid Email.';
      }
    }
  }
`;

export const StyleSubTitle = styled.div`
  margin-bottom: 14px;
  & strong {
    font-size: 24px;
  }
  & span {
    margin-left: 20px;
    font-size: 14px;
    color: #555;
  }
`;
